export const LegalLinks = ({ light = false, className = "" }) => (
  <p data-testid="legal-links" className={`text-center text-xs ${light ? "text-white/70" : "text-muted-foreground"} ${className}`}>
    <a href="https://veloktify.com/terms" target="_blank" rel="noopener noreferrer" data-testid="terms-link"
      className="font-semibold underline underline-offset-2">Terms of Service</a>
    {" · "}
    <a href="https://veloktify.com/privacy" target="_blank" rel="noopener noreferrer" data-testid="privacy-link"
      className="font-semibold underline underline-offset-2">Privacy Policy</a>
  </p>
);
